import { defineMessages } from 'react-intl';

export default defineMessages({
    DefaultPriceTitle: {
        id: 'common.components.addons.DefaultPriceTitle',
        defaultMessage: 'Annual price'
    },
    MonthlyPriceTitle: {
        id: 'common.components.addons.MonthlyPriceTitle',
        defaultMessage: 'Monthly price'
    },
    DefaultAddLabel: {
        id: 'common.components.addons.DefaultAddLabel',
        defaultMessage: 'Add'
    },
    DefaultRemoveLabel: {
        id: 'common.components.addons.DefaultRemoveLabel',
        defaultMessage: 'Remove'
    },
    Selected: {
        id: 'common.components.addons.Selected',
        defaultMessage: 'Selected'
    },
    AnnualPriceWhenMonthly: {
        id: 'common.components.addons.AnnualPriceWhenMonthly',
        defaultMessage: 'Annual price: +£{amount}'
    },
    PerYear: {
        id: 'common.components.addons.PerYear',
        defaultMessage: '/year'
    }
});
